import * as firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyAgUFauSFuptg_IRMzBBzbDRQKKU8C2plo',
  authDomain: 'media-beast.firebaseapp.com',
  databaseURL: 'https://media-beast.firebaseio.com',
  projectId: 'media-beast',
  storageBucket: 'media-beast.appspot.com',
  messagingSenderId: '658602371228',
  appId: '1:658602371228:web:a15d628d2dfb0af0',
};

firebase.initializeApp(config);

export const firestoreRef = firebase.firestore;
export const fireAuthRef = firebase.auth;
export const firestore = firebase.firestore();
export const storage = firebase.storage();
export const firebaseAuth = firebase.auth();

export const dbRefs = {
  scheduleRef: firestore.collection('schedule'),
  perfAreasRef: firestore.collection('performanceAreas'),
  homeRef: firestore.collection('siteData').doc('homeContent'),
  aboutRef: firestore.collection('siteData').doc('aboutContent'),
  carnivalRef: firestore.collection('siteData').doc('carnivalContent'),
  contactRef: firestore.collection('siteData').doc('contactContent'),
  ticketsRef: firestore.collection('siteData').doc('ticketContent'),
  eventRef: firestore.collection('siteData').doc('event'),
  footerRef: firestore.collection('footer'),
  filesRef: firestore.collection('files'),
  filesRef2: firestore.collection('files2'),
  imgRef: firestore.collection('images'),
  sponsorRef: firestore.collection('sponsors'),
  themesRef: firestore.collection('themes'),
  newsRef: firestore.collection('subscribers'),
  flierRef: firestore.collection('fliers'),
  errorRef: firestore.collection('errors'),
  galleryRef: firestore.collection('galleries'),
};

export const firestoreChangeTypes = {
  added: 'added',
  modified: 'modified',
  removed: 'removed',
};
